/* eslint-disable id-length */
export function sortAlphabetically(a: unknown, b: unknown, caseSensitivity = false): number {
  let item1 = a || '';
  let item2 = b || '';

  if (!caseSensitivity) {
    item1 = typeof item1 === 'string' ? item1.toLowerCase() : item1;
    item2 = typeof item2 === 'string' ? item2.toLowerCase() : item2;
  }

  if (!item1) {
    return 1;
  }

  if (!item2) {
    return -1;
  }

  if (item1 < item2) {
    return -1;
  }

  if (item1 > item2) {
    return 1;
  }

  return 0;
}
